import {
  Button,
  type ButtonProps,
  CircularProgress,
  Typography
} from "@mui/material";
import React, { forwardRef } from "react";

import { classes } from "@/utils/css";

import styles from "./AppButton.module.css";

export type AppButtonProps = Omit<ButtonProps, "variant" | "size" | "type"> & {
  loading?: boolean;
  type?: "filled" | "outlined";
  variant?:
    | "primary"
    | "info"
    | "success"
    | "danger"
    | "warning"
    | "dark"
    | "gray"
    | "gray_dark"
    | "light";
  size?: "sm" | "md" | "lg";
  label?: string;
  buttonType?: ButtonProps["type"];
  icon?: React.ReactNode;
  containerStyle?: React.CSSProperties;
};

function _AppButton(
  {
    type = "filled",
    variant = "primary",
    size = "lg",
    buttonType = "button",
    containerStyle,
    ...props
  }: AppButtonProps,
  ref: React.Ref<HTMLButtonElement>
): JSX.Element {
  return (
    <div className={styles.wrapper} style={containerStyle}>
      <Button
        ref={ref}
        {...props}
        type={buttonType}
        className={
          props.loading
            ? classes(
                styles.button,
                styles[type],
                styles[variant],
                styles[size],
                styles.disabled,
                props.className || ""
              )
            : classes(
                styles.button,
                styles[type],
                styles[variant],
                styles[size],
                props.className || ""
              )
        }
        style={{
          borderRadius: props.style?.borderRadius || "4px",
          ...props.style
        }}
        onClick={(event) => {
          event.preventDefault();
          props.onClick && props.onClick(event);
        }}
      >
        {!props.icon ? null : (
          <span
            style={{
              display: "inline-flex",
              alignItems: "center"
            }}
          >
            {props.icon}
          </span>
        )}
        {props.label ? (
          <Typography
            variant="inherit"
            className={classes(styles.label)}
            noWrap
          >
            {props.label}
          </Typography>
        ) : null}
      </Button>
      {props.loading ? (
        <CircularProgress size={20} className={styles.buttonProgress} />
      ) : null}
    </div>
  );
}
const AppButton = forwardRef(_AppButton);
export default AppButton;
